import Button from "@material-ui/core/Button";
import History from "@material-ui/icons/History";
import ErrorIcon from "@material-ui/icons/Report";
import { FC } from "react";
import { Title } from "react-admin";
import { useHistory } from "react-router-dom";

interface ErrorProps {
  error: any;
  errorInfo?: any;
  [x: string]: any;
}

const Error: FC<ErrorProps> = ({ error, errorInfo, ...props }) => {
  const history = useHistory();

  return (
    <div>
      <Title title="Error" />
      <h1>
        <ErrorIcon /> Something Went Wrong{" "}
      </h1>
      <div>An error has occurred and your request couldn't be completed.</div>
      <div>
        If you need help or support, please contact
        <a
          href={
            process.env.REACT_APP_GENERIC_SUPPORT_EMAIL ||
            "servicedesk@transpower.co.nz"
          }
          target="_top"
        >
          Send Mail
        </a>
      </div>
      {process.env.NODE_ENV !== "production" && (
        <details>
          <h2>{error.toString()}</h2>
          {errorInfo?.componentStack}
        </details>
      )}
      <div>
        <Button
          variant="contained"
          color="primary"
          endIcon={<History />}
          onClick={() => history.go(-1)}
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default Error;
